/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemCancelPreviewExamViewModel } from "../types/ExamItemCancelPreviewExamViewModel.ts";

export const examItemCancelPreviewExamViewModelSchema = z.object({
  title: z
    .string()
    .describe("Título da prova que contém a questão a ser cancelada.")
    .nullish(),
}) as unknown as ToZod<ExamItemCancelPreviewExamViewModel>;
